/* globals jQuery, Vue */

import Vue from 'vue/dist/vue.js';

/**
 * This is a custom geo nav input component.
 * This javascript behaves in input_geo_nav.html.twig file with needs to be included
 */
(($) => {
    'use strict';

    const MIN_SEARCH_LENGTH = 2;
    const AJAX_DONE = 4;
    const DEFAULT_URL = '/front/geo/search';
    const COMPONENT = 'form[data-component="geo_nav_input"]';
    const parentComponent = document.getElementById("filters-modal");
    let componentList = parentComponent ? parentComponent.querySelectorAll(COMPONENT) : null;

    if (componentList) {
        initializeComponent();
    }

    function initializeComponent() {
        componentList.forEach(setComponentFunctionality);
    }

    /**
     * Add functionality to a detected component
     * @param {Object|Node} element
     */
    function setComponentFunctionality(element) {
        const pho = element.getAttribute('data-pho');
        const defaultPho = element.getAttribute('data-default-pho');
        const selectedId = element.getAttribute('data-selected-id');
        const selectedNeighborhoodId = element.getAttribute('data-selected-neighborhood-id');

        /* eslint-disable no-new */
        window.inputGeoNav = new Vue({
            el: element,
            data() {
                return {
                    placeholder: pho,
                    getPromise: null,
                    spinner: false,
                    query: element.getAttribute('data-selected-name'),
                    className: '',
                    results: [],
                    noResultsLabel: element.getAttribute('data-no-results') || '',
                    clearBtn: false,
                    dataId: selectedId,
                    dataNeighborhoodId: selectedNeighborhoodId,
                    dataType: '',
                    isFilled: false
                };
            },
            computed: {
                hasMinimumLength() {
                    return this.query.length > MIN_SEARCH_LENGTH;
                },
                isCp() {
                    return !isNaN(this.query);
                }
            },
            methods: {
                onFocus() {
                    this.isFilled = true;
                    this.placeholder = defaultPho;

                    const input = this.$refs['input'];
                    input.value = '';
                    input.value = this.query;

                    setTimeout(() => {
                        input.focus();
                        if (input.scrollWidth) {
                            input.scrollLeft = input.scrollWidth;
                        }
                        this.evaluateQuery();
                    }, 1);
                },
                onBlur() {
                    this.placeholder = pho;
                    this.spinner = false;
                },
                evaluateQuery() {
                    if (!this.isCp) {
                        this.evaluatePopulation();
                    }
                },
                onSubmit() {
                    if (this.isCp) {
                        window.Namespace.utilities.updateQueryStringParam('cp', this.query);
                        window.location.reload();
                    }
                },
                async evaluatePopulation() {
                    if (this.hasMinimumLength) {
                        this.abortPreviousRequest();
                        this.spinner = true;
                        this.clearBtn = false;
                        this.isFilled = false;

                        try {
                            const response = await this.getQueryResults();
                            this.results = JSON.parse(response);
                            if (this.results.length === 0) {
                                this.results = [{
                                    id: '0',
                                    label: this.noResultsLabel
                                }];
                            }
                            this.spinner = false;
                            this.clearBtn = true;
                            this.isFilled = true;
                        } catch (error) {
                            this.spinner = false;
                            this.clearResults();
                        }
                    } else {
                        this.clearResults();
                    }
                },
                getQueryResults() {
                    return $.get(`${DEFAULT_URL}?q=${this.query}`);
                },
                abortPreviousRequest() {                    
                    if (this.getPromise && this.getPromise.readyState !== AJAX_DONE) {                        
                        this.getPromise.abort();
                    }
                },
                navigateTo(dirify) {
                    window.location.href = dirify;
                },
                printOption(value, id, type, neighborhoodId) {
                    this.query = value;
                    this.dataId = id;
                    this.dataNeighborhoodId = neighborhoodId;
                    this.dataType = type;
                    this.className = 'autocomplete-with-result';
                    this.clearResults();
                },
                clearResults() {
                    this.results = [];
                    this.clearBtn = false;
                    this.isFilled = false;
                },
                clearQuery() {
                    this.query = '';
                    this.className = '';
                    this.dataId = 0;
                    this.clearResults();
                    this.placeholder = defaultPho;
                },
                resetAutoComplete() {
                    this.clearResults();
                }
            },
            directives: {
                clickOutside: {
                    bind(el, binding, vnode) {
                        el.event = (event) => {
                            if (!(el === event.target ||
                                    el.contains(event.target) ||
                                    event.target.classList.contains('c-auto-complete-item') ||
                                    event.target.classList.contains('c-auto-complete-list'))) {
                                vnode.context[binding.expression](event);
                            }
                        };
                        document.body.addEventListener('click', el.event);
                    },
                    unbind(el) {
                        document.body.removeEventListener('click', el.event);
                    }
                }
            }
        });
    }

})(jQuery);
